import React from 'react';
import EducatorNote from './EducatorNote';
import useQuery from './useQuery';

export default function useMapping(props) {
  const models = useQuery(props);

  const type = 'eudcator-note';

  const entries = models.data.map((value, index) => ({
    type: type,
    value: (
      <EducatorNote
        key={`${type}-${index}`}
        note={value}
      />
    ),
    data: value,
    timestamp: value.data.createdAt
  }));

  return {
    models,
    entries
  };
}
